import React, { useEffect } from 'react';
import styled from 'styled-components';
import { Dialog, Steps } from 'tdesign-react';
import { connect } from 'react-redux';
import { QUICK_DEPLOY_STEPS, resetQuickDeploy } from '@/slices/clusterSlice';
import { fetchEnvOptions } from '@/slices/resourceSlice';
import { CLUSTER_TYPES } from '@/utils/constant';
import { fetchQuickDeployFlow } from '@/slices/execFlowSlice';
import { fetchVariableStencilList } from '@/slices/variableSlice';
import { isVoid } from '@/utils/common';
import SelectClusterTypeStep from './SelectClusterTypeStep';
import ChoiceClusterStep from './ChoiceClusterStep';
import MaintainHostsStep from './MaintainHostsStep';
import MaintainK8sStep from './MaintainK8sStep';
import ChoiceClusterStepK8s from './ChoiceClusterStepK8s';

const { StepItem } = Steps;

// 创建集群对话框
function CreateClusterModal({
  visible,
  handleClose,
  resetQuickDeploy,
  currentStep,
  clusterType,
  fetchEnvOptions,
  fetchQuickDeployFlow,
  fetchVariableStencilList,
  ...others
}) {
  useEffect(() => {
    if (visible) {
      fetchQuickDeployFlow();
      fetchEnvOptions();
    } else {
      resetQuickDeploy();
    }
  }, [visible, resetQuickDeploy, fetchQuickDeployFlow, fetchEnvOptions]);

  useEffect(() => {
    if (isVoid(clusterType)) return;
    fetchVariableStencilList({ scopeType: clusterType });
  }, [clusterType, fetchVariableStencilList]);

  return (
    <Modal
      header='创建集群'
      onCloseBtnClick={handleClose}
      onEscKeydown={handleClose}
      width={[QUICK_DEPLOY_STEPS.MAINTAIN_HOSTS].includes(currentStep) ? '80%' : 550}
      visible={visible}
      placement='center'
      footer={null}
      {...others}
    >
      <Content>
        {clusterType === CLUSTER_TYPES.HOST && (
          <Steps theme='dot' current={currentStep} readonly>
            <StepItem value={QUICK_DEPLOY_STEPS.SELECT_CLUSTER_TYPE} title='部署类型' />
            <StepItem value={QUICK_DEPLOY_STEPS.CHOICE_CLUSTER} title='选择集群' />
            <StepItem value={QUICK_DEPLOY_STEPS.MAINTAIN_HOSTS} title='主机资源' />
          </Steps>
        )}
        {clusterType === CLUSTER_TYPES.K8S && (
          <Steps theme='dot' current={currentStep} readonly>
            <StepItem value={QUICK_DEPLOY_STEPS.SELECT_CLUSTER_TYPE} title='部署类型' />
            <StepItem value={QUICK_DEPLOY_STEPS.MAINTAIN_K8S} title='K8s资源' />
            <StepItem value={QUICK_DEPLOY_STEPS.CHOICE_CLUSTER} title='选择集群' />
          </Steps>
        )}
        {currentStep === QUICK_DEPLOY_STEPS.SELECT_CLUSTER_TYPE && <SelectClusterTypeStep />}
        {currentStep === QUICK_DEPLOY_STEPS.CHOICE_CLUSTER &&
          (clusterType === CLUSTER_TYPES.K8S ? <ChoiceClusterStepK8s /> : <ChoiceClusterStep />)}
        {currentStep === QUICK_DEPLOY_STEPS.MAINTAIN_HOSTS && <MaintainHostsStep />}
        {currentStep === QUICK_DEPLOY_STEPS.MAINTAIN_K8S && <MaintainK8sStep />}
      </Content>
    </Modal>
  );
}

export default connect(
  (state) => ({
    currentStep: state.cluster.quickDeploy.currentStep,
    clusterType: state.cluster.quickDeploy.clusterType,
  }),
  {
    resetQuickDeploy,
    fetchEnvOptions,
    fetchQuickDeployFlow,
    fetchVariableStencilList,
  },
)(CreateClusterModal);

const Modal = styled(Dialog)`
  .t-dialog__body {
    padding-bottom: 0;
  }
`;

const Content = styled.div`
  .t-steps {
    .t-steps-item:not(:last-child)::after {
      width: calc(100% - 82px);
      left: calc(140px / 2 + 12px);
      top: 11px;
    }
    .t-steps-item__inner {
      flex-direction: row;
      .t-steps-item__content {
        width: 60px;
      }
    }
    .t-steps-item__title {
      font-size: 14px;
    }
  }
`;
